import { logic as apiLogic } from 'api'
import ChannelsFloorspaceModalLogic from 'ChannelsFloorspaceModal/logic'
import completeness from 'components/Completeness/logic'
import homeLogic from 'home/logic'
import localeLogic from 'locale/logic'
import appLogic from 'logic'
import myResultsLogic from 'MyResults/logic'
// import preCacheRequestLogic from 'preCacheRequest/logic'
import rankingsLogic from 'rankings/logic'
import { logic as searchLogic } from 'search'

export default [
  ...apiLogic,
  ...appLogic,
  ...ChannelsFloorspaceModalLogic,
  ...completeness,
  ...homeLogic,
  ...localeLogic,
  ...myResultsLogic,
  // ...preCacheRequestLogic, // TODO: Adjust preCache with new endpoints
  ...rankingsLogic,
  ...searchLogic,
]
